<template>
  <div class="stockRemind_box">
      <div class="check_Top">
        
        <div class="check_desc">
            <el-button size="medium"  @click="goBack()"  type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
        </div>
        <div style="font-size:18px;text-align:center;">{{text}}</div>
      </div>
 
       

      <Inventory  @updateText="updateText"    />

     
   
      
  </div>
</template>

<script>
import Inventory from '../../home/inventoryRp'
import { mapState, mapActions, mapMutations } from "vuex";
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import dialogPlugin from '../component/diaload'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import jsonp from '../../../api/jsonp';
import mygoods from '../../../api/moudles/mygoods';
import neworderApi from '../../../api/moudles/newOrders'
import distributionApi from '../../../api/moudles/distribution'
import md5 from 'js-md5'
import userStoreItems from '../../../api/moudles/userStoreItems';
import { resolve } from 'path';
import { chownSync } from 'fs';
export default {
data(){
return{
   type:0,
   text:''
}
},

components: {
    Inventory
    
},

 computed: {
    ...mapState({
      userName: (state) => state.shopaccess.userInfo.userName,
      userId: (state) => state.shopaccess.userInfo.userId,
     
    }),

 
    
},

watch:{
    
   
},


created(){
    this.type=this.$route.query.stockType

    if(this.type == 1){
        this.text=this.$t('other.a202')
    }
    if(this.type == 2){
        this.text=this.$t('other.a203')
    }
},
destroyed(){
    // utils.cleanStorageData()
},
methods:{
    goBack(){
     if(this.$route.query.type == 0){
         this.$router.push('/stockProduct/single')
     }else if(this.$route.query.type == 1){
          this.$router.push('/stockProduct/combo')
     }else if(this.$route.query.type == 2){
         this.$router.push('/stockProduct/gift')
     }
    },
    updateText(type){
        console.log('type',type)
        if(type.type == 1){
            this.text=this.$t('other.a202')
        }
        if(type.type == 2){
            this.text=this.$t('other.a203')
        }
        if(type.type == 0){
            this.text=this.$t('other.a358')
        }
    }
}

 









}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
/deep/ .el-dropdown-menu__item{
        font-size: 22px;
        line-height: 45px;
}

/deep/ .el-table .warning-row {
background: oldlace;
}



.avatar-uploader .el-upload {
border: 1px dashed #d9d9d9;
border-radius: 6px;
cursor: pointer;
position: relative;
overflow: hidden;
}
.avatar-uploader .el-upload:hover {
border-color: #409EFF;
}
.avatar-uploader-icon {
font-size: 28px;
color: #8c939d;
width: 178px;
height: 178px;
line-height: 178px;
text-align: center;

border: 1px solid #000;
border-radius: 5px;
}


.avatar {
width: 178px;
height: 178px;
display: block;
}

.upload__tip{
    font-size:20px;
}

.ogitg{
    margin: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #757575;
}

.stockRmind_box{
    background-color: rgba(226, 222, 222, 0.5);
    min-height: 100vh;
    box-sizing: border-box;
    padding-top:150px ;

    

    .el-icon-edit{
        cursor: pointer;
        color: #409EFF;
        font-size: 18px;
        margin-left:10px ;
    }

  .kvhkfn{
      color: #409EFF;
      cursor: pointer;
      width: 150px;
      text-align: center;
  }  


  .header_tip{
      background: #fff ;
     
      padding: 6px 0;

      .ivmfjn{
          display: flex;
          align-items: center;
          padding-left:15px
      }

      
  }

  .menu{
          margin-right: 20px;
      }



  .basic_info{
       
        background-color: #fff;
        padding: 0 16px;
        margin: 35px 10px 10px 10px;


        .skuDesc{
            font-size: 18px;
            font-weight: bold;
            margin: 20px 10px;
        }

        .itemskuImg{
            width: 150px;
            height: 150px;
            border: 1px solid #eee;
            border-radius: 3px;
            overflow: hidden;

            

            img{
                width: 100%;
            }
        }

        .el-icon-edit-outline{
            font-size: 17px;
            margin-left: 15px;
            color: #409EFF;
            cursor: pointer;
        }

        .lknf{
             font-size: 17px;
            margin-left: 15px;
            color: #409EFF;
            cursor: pointer;
        }

        .btn{
            margin: 3px 0;
            
            
        }
        .pic_box{
            width: 80px;
            height: 80px;
            border: 1px solid #eee;
            overflow: hidden;
            border-radius: 5px;
        }
        .title{
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail{
            padding: 15px 0;
            
        }
     
    }

 


    

    .check_desc{
        @include flex-between();
        margin: 10px 0;
        padding-right: 20px;

     
    }
    .check_Top{
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 205px);
        background-color: #fff;
        border-bottom: 1px solid #eee;
      

    }

   
  
}

</style>